module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Interactive', {
    on: {
      "click": _vm.displaySelection
    }
  }), _c('div', [_c('span', [_vm._v("Origin : " + _vm._s(_vm.origin))])]), _c('div', [_c('span', [_vm._v("Cylinders : " + _vm._s(_vm.cylinders))])]), _c('div', [_c('span', [_vm._v("Records : " + _vm._s(_vm.records))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6016972c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./_docs/partials/examples/EventInteractivityExample.vue
// module id = 1644
// module chunks = 1